import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICONS } from '../../icons';
import SidebarProfileHeader from './SidebarProfileHeader';
import appLogo from '../../assets/png/appLogo.png';
import iconLogo from '../../assets/streamQuestOnlyLogo.png';

export default function DashboardSidebar({
  tabs, activeTab, onTabChange,
  userData,
  collapsed, onToggleCollapse, onLogout
}) {
  return (
    <aside className={`dashboard-sidebar ${collapsed ? 'collapsed' : ''}`}>
      {/* Brand */}
      <div className="sidebar-brand">
        <img src={collapsed ? iconLogo : appLogo} alt="StreamQuest" className="sidebar-logo" />
        <button
          className="sidebar-collapse-btn"
          onClick={onToggleCollapse}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <FontAwesomeIcon icon={collapsed ? ICONS.CHEVRON_RIGHT : ICONS.CHEVRON_LEFT} />
        </button>
      </div>

      {/* Profile Header — avatar, username, clickable to open profile */}
      <div className={`sidebar-profile-header-section ${activeTab === 'profile' ? 'active' : ''}`}>
        <SidebarProfileHeader
          userData={userData}
          collapsed={collapsed}
          isActive={activeTab === 'profile'}
          onProfileClick={() => onTabChange('profile')}
        />
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`sidebar-item ${activeTab === tab.id ? 'active' : ''} ${tab.prominent ? 'prominent' : ''}`}
            onClick={() => onTabChange(tab.id)}
            title={collapsed ? tab.label : undefined}
          >
            <FontAwesomeIcon icon={tab.icon} className="sidebar-item-icon" />
            {!collapsed && <span className="sidebar-item-label">{tab.label}</span>}
            {tab.count > 0 && (
              <span className={`sidebar-item-count ${collapsed ? 'collapsed' : ''}`}>
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button className="sidebar-logout-btn" onClick={onLogout} title="Logout">
          <FontAwesomeIcon icon={ICONS.LOGOUT} />
          {!collapsed && <span>Logout</span>}
        </button>
        {!collapsed && (
          <span className="sidebar-version">v{process.env.REACT_APP_VERSION?.replace('v', '') || '0.5.0'}</span>
        )}
      </div>
    </aside>
  );
}
